import React from 'react';

const InvisibleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M17.97 5.3L19 6.33l-2 2.01c1.24 1.23 2 2.53 2 3 0 .95-3.36 5.62-7.5 5.62-.9 0-1.76-.22-2.55-.57L6.33 19 5.3 17.97 17.97 5.3zm-2.88 4.94l-1.9 1.9c-.18.39-.5.7-.88.88l-1.9 1.9a3.74 3.74 0 004.84-3.59c0-.38-.06-.74-.16-1.09zM11.5 5.71c1 0 1.95.27 2.83.7l-1.45 1.44a3.74 3.74 0 00-4.87 4.86l-1.8 1.81C4.83 13.24 4 11.82 4 11.33c0-1 3.36-5.63 7.5-5.63zm-.24 3.76L9.64 11.1c.11-.84.77-1.5 1.61-1.62z" />
  </svg>
);

export default InvisibleIcon;
